const tableCellServiceType = {
  Typography: 'Do you really want to delete this item?'
};

export default tableCellServiceType;
